<template>
  <div v-if="voteEnabled" class="vote">
    <BaseShape
      :class="['vote__svg', voted ? 'vote__svg--animate' : '']"
      viewBox="0 0 18 17"
    >
      <HeartIcon />
    </BaseShape>
    <p class="vote__text">Подобається {{ likes }}</p>
    <button
      class="vote__btn"
      @click.prevent="like"
      type="button"
      :class="['btn', disabled ? 'btn--disabled' : '']"
    >
      {{ voted ? voteObj.unvote : voteObj.vote }}
    </button>

    <BaseModal :opened="isOpened" @close="isOpened = false" position="center">
      <template slot="body">
        <span class="vote__error">
          {{ textErrorModal}}
        </span>
      </template>
    </BaseModal>
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SocialBtnsList from '~/components/SocialBtnsList'
import HeartIcon from '~/components/_SVG/HeartIcon'

export default {
  inject: ['voteObj'],
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isOpened: false,
      likes: 0,
      disabled: false,
      voted: null,
      textErrorModal: '',
    }
  },
  components: {
    SocialBtnsList,
    HeartIcon,
  },
  computed: {
    ...mapGetters({
      loggedIn: 'auth/loggedIn',
      openedModal: 'common/openedModal',
      activeCategory: 'participants/activeCategory',
    }),
    voteEnabled() {
      return this.messages.global.voteEnabled
    },
    showText() {
      if (this.disabled && !this.loggedIn) {
        return 'Для голосування потрібно увійти'
      } else if (this.disabled && this.loggedIn) {
        return '...'
      } else {
        return 'Голосувати'
      }
    },
  },
  methods: {
    ...mapActions('auth', ['vote', 'unVote']),
    async like() {
      if (this.loggedIn) {
        try {
          this.disabled = true

          if (!this.voted) {
            try {
              const { data } = await this.vote(this.item.id)
              this.likes = data.likes

              this.$store.commit('participants/UPDATE_PARTICIPANT', {
                categoryId: this.activeCategory,
                itemId: this.item.id,
                likes: this.likes,
                liked: true,
              })
            } catch (er) {
              this.textErrorModal = er.response.data.popupMessage
              this.disabled = false
              this.isOpened = true
              return null
            }
          } else {
            const { data } = await this.unVote(this.item.id)
            this.likes = data.likes

            this.$store.commit('participants/UPDATE_PARTICIPANT', {
              categoryId: this.activeCategory,
              itemId: this.item.id,
              likes: this.likes,
              liked: false,
            })
          }

          this.voted = !this.voted
          this.disabled = false
        } catch ({ response }) {
          this.$log(response)
        }
      }
    },
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.disabled = false
      }
    },
  },
  created() {
    this.likes = this.item.likes
    this.voted = this.item.liked

    if (!this.loggedIn) {
      this.disabled = true
    } else {
      this.disabled = false
    }
  },
}
</script>

<style lang="scss">
.vote {
  display: flex;
  align-items: center;

  &__error {
    font-family: ToyotaType-Book, sans-serif;
    color: #282830;
    font-size: 13px;
    font-weight: 700;
    line-height: 24px;    
  }

  &__text {
    margin: 0 auto 0 0;
    color: #595d60;
    font-family: $ToyotaBook;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }

  &__svg {
    fill: #ff0022;
    margin-right: 10px;
  }

  &__btn {
    @include easeOut;
    @include button-reset;

    width: 132px;
    min-height: 46px;
    color: #ffffff;
    font-family: $ToyotaBook;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    border-radius: 24px;
    background-color: #ff0022;

    &:not(.btn--disabled):hover {
      background-color: #d90022;
    }
  }
}

@include media-min($tablet-width) {
  .vote {
    &__error {
      font-size: 17px;
      line-height: 23px;
      font-weight: 700;
    }
  }
}

@include media-min($desktop-width) {
  .vote {
    &__svg {
      width: 24px;
      height: 22px;
    }

    &__text {
      margin-right: 16px;
      font-size: 16px;
      line-height: 25.6px;
    }

    &__btn {
      width: 174px;
      font-size: 16px;
      line-height: 20px;
    }
  }
}

@keyframes increaseInSize {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale(1.5);
  }
}
</style>



// WEBPACK FOOTER //
// components/VotingBlock.vue